import apiUseCases from "@src/cloud-connect/api";
import { extractFileNameFromContentDisposition } from "@src/cloud-connect/utils/extract-filename";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { DownloadResult } from "@src/types/ota-update";

export const downloadFirmwareBackupUseCase = async (
  firmwareId: string,
): Promise<DownloadResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const sourceId = store.getState().yourSlice.connectionView.source.source_id;
    const response = await apiUseCases.downloadFirmwareBackup(
      namespace,
      sourceId,
      firmwareId,
    );

    if (response == null) {
      return {
        success: true,
        handledDirectly: true,
      };
    }

    const contentDisposition = response.headers["content-disposition"];
    const filename = extractFileNameFromContentDisposition(contentDisposition);

    return {
      success: true,
      data: response.data,
      filename,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to download firmware backup")
        .message,
    };
  }
};
